/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliGroupDtoApiResponse } from '../../models/amoxcalli-group-dto-api-response';
import { AmoxcalliUpdateGroupDto } from '../../models/amoxcalli-update-group-dto';

export interface ApiGroupsIdPut$Json$Params {
  id: string;
      body?: AmoxcalliUpdateGroupDto
}

export function apiGroupsIdPut$Json(http: HttpClient, rootUrl: string, params: ApiGroupsIdPut$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliGroupDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, apiGroupsIdPut$Json.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliGroupDtoApiResponse>;
    })
  );
}

apiGroupsIdPut$Json.PATH = '/api/groups/{id}';
